import { DriverModel } from './../../driver/models/driver.model';
import { DriverService } from './../../driver/models/driver.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PersonModel } from '../../person/models/person.model';
import { PersonService } from '../../person/models/person.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

import { Location } from '@angular/common';
import { OrganizationService } from "../models/organization.service";

@Component({
  selector: 'wego-Orgdriver-list',
  template: require('../views/organizationdriver-list.component.html'),
  providers: [DriverService,  OrganizationService],
})
export class OrganizationDriverComponent implements OnInit {
  DataListModel: DataListModel;
  driverList: DriverModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  isParentCheck: boolean;
  apiResponse: IAPIResponse;
  urlDefaultPage: string;
  errorMessage: string;
  errorModel: IKeyValueInterface[];
  urlOrganizationList: string;
  organizationHashId: string;
  organizationName:string;
  urlPersonUpdate: string;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  get isAnyChecked(): boolean {
    if (this.driverList) {
      let isCheck = this.driverList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.driverList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private organizationService: OrganizationService,
    private driverService: DriverService,    
    private activeRoute: ActivatedRoute
    , private router: Router
    , private authService: AuthService
    , private translate: TranslateService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblDriver')
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOrganizationList = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_LIST);
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    
    this.activeRoute
      .params
      .subscribe(params => {
        let organizationHashId = params['organizationHashId'] || '';
        if (organizationHashId != '') {
          this.organizationHashId = organizationHashId;
          this.GetOrganizationDriverList();
          this.GetOrganizationByHashId();
        }
      });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.organizationService.ExportOrganizationDriverList(this.organizationHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "OrganizationDrivers" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }
  public RedirectoPerson(personHashId: string) {
    this.router.navigate([this.urlPersonUpdate, { personId: personHashId }]);
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOrganizationDriverList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetOrganizationDriverList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOrganizationDriverList();
  };

  public OnPagingChange(event: any) {   
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOrganizationDriverList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.driverList.forEach(x => x.isChecked = isChecked);
  }


  public GetOrganizationDriverList() {
    this.isLoading = true;
    this.organizationService.GetOrganizationDriverList(this.organizationHashId, this.DataListModel)
      .subscribe(
      res => {
        this.driverList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetOrganizationByHashId() {
    this.organizationService.GetOrganizationBasicDetail(this.organizationHashId)
      .subscribe(
      res => {
        this.organizationName = res.data.entityName;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organization/components/organizationdriver-list.component.ts